<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row mb-2">
            <div class="col-md-12 d-flex justify-content-center align-items-center">
                <img [src]="imageUrl"/>
            </div>
        </div>
    </div>
</div>
